<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit exam grade group" onOk="handleOk"  :width="680" style="top: 20px;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Exam Grade Group</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <div class="row">
            <div class="col-md-12">
              <a-form-item label="Name">
                <a-input
                  placeholder="Name"
                  v-decorator="['name', {rules: [{ required: true, message: 'Please input exam type name!' }]}]"
                />
              </a-form-item>
            </div>
            <div class="col-md-12">
              <a-form-item label="Description">
                <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['grade_group_description']" />
              </a-form-item>
            </div>
            <div class="col-md-12">
              <a-form-item label="Is Default?">
                <a-switch
                  checkedChildren="Yes" unCheckedChildren="No"
                  v-decorator="[
                    'is_default',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <!-- Grades -->
            <div class="col-md-12">
              <div>
                <div class="row align-items-center">
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-dark mb-0">Grades:</p>
                  </div>
                  <div class="col-sm-8 text-sm-right">
                    <button
                      type="button"
                      class="btn btn-sm btn-danger btn-with-addon mr-2"
                      @click="handleRemoveRow"
                    >
                      <span class="btn-addon">
                        <i class="btn-addon-icon fe fe-minus-circle" />
                      </span>
                      Remove row
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-primary btn-with-addon"
                      @click="handleAddRow"
                    >
                      <span class="btn-addon">
                        <i class="btn-addon-icon fe fe-plus-circle" />
                      </span>
                      Add row
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>Grade Name</th>
                        <th>Min Score %</th>
                        <th>Credit Point</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="index in gradesCount" :key="index">
                        <td style="min-width:100px;">
                          <a-form-item class="d-none">
                            <a-input
                              placeholder="Name"
                              v-decorator="[`grades[${index}][id]`, {initialValue: null}]"
                            />
                          </a-form-item>
                          <a-form-item>
                            <a-input
                              placeholder="Name"
                              v-decorator="[`grades[${index}][name]`, {rules: [{ required: true, message: 'Please input grade name!' }]}]"
                              style="width: 100%;"
                            />
                          </a-form-item>
                        </td>
                        <td style="min-width:100px;">
                          <a-form-item>
                            <a-input-number
                              placeholder="%"
                              v-decorator="[`grades[${index}][grade_min_score_pc]`, {rules: [{ required: true, message: 'Please input min score %' }] }]"
                              :min="0"
                              :max="100"
                              style="width: 100%;"
                            />
                          </a-form-item>
                        </td>
                        <td style="min-width:100px;">
                          <a-form-item>
                            <a-input-number
                              placeholder="Credit Point"
                              v-decorator="[`grades[${index}][grade_credit_point]`, {rules: [{ required: true, message: 'Please input min score %' }] }]"
                              :min="0"
                              :max="100"
                              style="width: 100%;"
                            />
                          </a-form-item>
                        </td>
                        <td style="min-width:150px;">
                          <a-form-item>
                            <a-input
                              placeholder="Description"
                              v-decorator="[`grades[${index}][grade_description]`, {rules: [{ required: false, message: 'Please input grade description!' }]}]"
                              style="width: 100%;"
                            />
                          </a-form-item>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { makeGradeData } from './fields'

export default {
  name: 'EditExamGrade',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      gradeGroupId: null,
      gradesCount: 1,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openExamGradesEditModal', this.showModal)
  },
  methods: {
    showModal: function(gradeGroupId, record) {
      this.gradeGroupId = gradeGroupId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.gradesCount = record.grades_count
      this.$http.get('/api/gradegroup/' + gradeGroupId).then(({ data }) => {
        const fieldsData = makeGradeData(data.data)
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    handleAddRow() {
      this.gradesCount++
    },
    handleRemoveRow() {
      if (this.gradesCount > 1) {
        this.gradesCount--
      }
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              const grades = values.grades.filter(element => element !== null)
              this.$http
                .patch('/api/grade/' + this.gradeGroupId, {
                  name: values.name,
                  grade_group_description: values.grade_group_description,
                  is_default: values.is_default,
                  grades: grades,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.gradesCount = 1
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Grade group edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
              this.gradesCount = 1
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
